import { TableCell } from './table-cell.component';
import { TableCheckbox } from './table-checkbox.component';
import { ITableRowProps } from './table.types';

export const TableRow = ({
  canFavorRow,
  favoritable,
  favorited,
  index,
  onFavorite,
  onClick,
  onDoubleClick,
  onSelect,
  rowClasses,
  selected,
  selectable,
  values
}: ITableRowProps) => {
  return (
    <tr
      className={`even:bg-gray-100 odd:bg-white border-b hover:bg-slate-100 ${onClick || onDoubleClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      {favoritable &&
        (canFavorRow ? (
          <TableCheckbox
            checked={favorited && favorited.length > index && favorited[index]}
            onChange={(v) => onFavorite?.(index, v)}
            variant="star"
          />
        ) : (
          <td />
        ))}
      {selectable && <TableCheckbox checked={selected ?? false} onChange={onSelect} />}
      {values.map(({ children, key }, i) => {
        // When favoritable is true, rowClasses has an extra element at index 0 for the favorite column
        // so we need to offset by 1 to align data values with their corresponding rowClasses
        const rowClassIndex = favoritable ? i + 1 : i;
        return (
          <TableCell
            key={key ?? 'table-row-child-' + i}
            rowClass={rowClasses?.length && rowClasses.length > rowClassIndex ? rowClasses[rowClassIndex] : undefined}
          >
            {children}
          </TableCell>
        );
      })}
    </tr>
  );
};
